/* global Blockly */
import React from 'react';
import util from "../../../../utils/es5Utils";
import {textBoxIcon} from "./index";

// everything in init should be ES5
function defineBlock(context) {
    return {
        init: function () {
            this.appendValueInput("COL")
                .appendField("set")
                .appendField(new Blockly.FieldImage(textBoxIcon, 30, 30, "text box icon", null), 'textBoxIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context,"textbox", undefined, '- select -'), "ID")
                .appendField(new Blockly.FieldDropdown([['background','BG'],['text','TXT']]), "TARGET")
                .appendField("colour to")
                .setCheck(["String", "Colour"]);
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setOutput(false); // add appropriate checks
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Set the text color of the specified widget');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#textboxes');
        },

        onchange: function(){
            if (this.getField('textBoxIcon') && this.getField('textBoxIcon').imageElement_)
                this.getField('textBoxIcon').setTooltip('Textbox');
        }
    }
}

function defineGenerators() {
    // TODO - this isn't a great method, must use setAttribute bc. dom.style.backgroundColor doesn't work for !important (and there are other !importants on Snap side
    //        that require use of !important).

    // generators dictionary in ES5
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue("ID");
            let background = block.getFieldValue('TARGET') === "BG";
            let colour = Blockly.JavaScript.valueToCode(block, 'COL', Blockly.JavaScript.ORDER_NONE);
            let styleElement = background?'background-color':'color';
            let code = "document.getElementById('" + id + "').style.setProperty('" + styleElement + "', " + colour + ", 'important');\n";
            return code;
        }
    }
}


const SetTextboxColour = function (props) {
    let name = "snap_set_textbox_colour";
    SetTextboxColour.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);

    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    let widgets = util.widgetsOfType(props.context, 'textbox');

    if (widgets.length < 1) {return null;}

    return (
        <block type={name}>
            {
                props.widget && (props.widget.id !== undefined)
                    ? <field name="ID">{props.widget.id}</field>
                    : null
            }
            <value name="COL">
                <shadow type="colour_picker"/>
            </value>
        </block>
    );
}

export default SetTextboxColour;